import Phaser from "phaser";
import type { BrickCellKind } from "../data/ChapterData.js";
import { PALETTE_NUM } from "../themes/palette.js";

export const PRESSURE_DANGER_ALPHA = 0.86;
export const PRESSURE_DANGER_MIN_ALPHA = 0.28;
export const PRESSURE_DANGER_BLINK_MS = 300;

const PRESSURE_DANGER_COLOR = PALETTE_NUM.signalDanger;
const PRESSURE_DANGER_PAD = 5;
const PRESSURE_DANGER_RADIUS = 7;

export interface BrickPressureDangerSpec {
  readonly kind: BrickCellKind;
  readonly x: number;
  readonly y: number;
  readonly displayWidth: number;
  readonly displayHeight: number;
  readonly baseFrameDisplayWidth: number;
  readonly baseFrameDisplayHeight: number;
  readonly pressureDanger: Phaser.GameObjects.Graphics;
}

export function drawBrickPressureDanger(spec: BrickPressureDangerSpec): void {
  const w = spec.kind === "gold" ? Math.min(spec.displayWidth, spec.baseFrameDisplayWidth) : spec.displayWidth;
  const h = spec.kind === "gold" ? Math.min(spec.displayHeight, spec.baseFrameDisplayHeight) : spec.displayHeight;
  const x = spec.x - w / 2 - PRESSURE_DANGER_PAD;
  const y = spec.y - h / 2 - PRESSURE_DANGER_PAD;
  spec.pressureDanger
    .clear()
    .lineStyle(3, PRESSURE_DANGER_COLOR, 1)
    .strokeRoundedRect(x, y, w + PRESSURE_DANGER_PAD * 2, h + PRESSURE_DANGER_PAD * 2, PRESSURE_DANGER_RADIUS)
    .fillStyle(PRESSURE_DANGER_COLOR, 0.08)
    .fillRoundedRect(x, y, w + PRESSURE_DANGER_PAD * 2, h + PRESSURE_DANGER_PAD * 2, PRESSURE_DANGER_RADIUS)
    .setActive(true)
    .setVisible(true);
}
